// Slug ↔ ISO-3166-alpha-2 mapping for clean checklist URLs.
//
// Public URL shape: /checklists/<slug> (e.g. /checklists/italy, /checklists/estonia).
// Internally NextStepsPage still works in terms of country codes; this module
// is the single source of truth for the bidirectional translation.

export type CountryCode =
  | 'IT' | 'AE' | 'PT' | 'ES' | 'CY' | 'EE' | 'TH' | 'MY' | 'ID' | 'GR' | 'MU' | 'AT';

export const CHECKLIST_SLUGS: Record<CountryCode, string> = {
  IT: 'italy',
  AE: 'uae',
  PT: 'portugal',
  ES: 'spain',
  CY: 'cyprus',
  EE: 'estonia',
  TH: 'thailand',
  MY: 'malaysia',
  ID: 'indonesia',
  GR: 'greece',
  MU: 'mauritius',
  AT: 'austria',
};

const SLUG_TO_COUNTRY: Record<string, CountryCode> = Object.entries(CHECKLIST_SLUGS).reduce(
  (acc, [code, slug]) => {
    acc[slug] = code as CountryCode;
    return acc;
  },
  {} as Record<string, CountryCode>,
);

export function slugToCountry(slug: string | undefined | null): CountryCode | null {
  if (!slug) return null;
  return SLUG_TO_COUNTRY[slug.toLowerCase()] ?? null;
}

export function countryToSlug(code: string | undefined | null): string | null {
  if (!code) return null;
  const upper = code.toUpperCase() as CountryCode;
  return CHECKLIST_SLUGS[upper] ?? null;
}

export function checklistPath(code: string): string {
  const slug = countryToSlug(code);
  // Fallback: unknown country falls back to query-param form so we never
  // produce a broken /checklists/null URL.
  return slug ? `/checklists/${slug}` : `/it/next-steps?country=${code}`;
}
